function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import colorVariable from "@mertasan/tailwindcss-variables/colorVariable";
export var baseColors = {
    transparent: "transparent",
    white: "#ffffff",
    current: "currentColor",
    blue: {
        medium: "#0077CD",
        light: "#00B6ED"
    },
    orange: {
        light: "#FFC46B",
        medium: "#E29117"
    },
    red: {
        medium: "#F32248"
    },
    gray: {
        dark: "#0F1012",
        medium: "#A9AEBB",
        mediumlight: "#DDDFF5",
        light: "#F7F8FC",
        900: ""
    },
    indigo: {
        50: "#EEF2FF",
        100: "#e0e7ff",
        200: "#c6d2ff",
        300: "#a3b3ff",
        400: "#7c86ff",
        500: "#615fff",
        600: "#4f39f6",
        700: "#432dd7",
        800: "#372aac",
        900: "#312c85",
        950: "#1e1a4d"
    }
};
export var colorVariables = _objectSpreadProps(_objectSpread({}, baseColors), {
    transparent: baseColors.transparent,
    bg: {
        default: baseColors.white,
        offdefault: baseColors.gray.light,
        inverted: baseColors.gray.dark
    },
    fg: {
        default: baseColors.gray.dark,
        inbetween: baseColors.gray.medium,
        inverted: baseColors.gray.light,
        error: baseColors.red.medium
    },
    brand: {
        primary: {
            base: baseColors.blue.medium,
            light: baseColors.blue.light
        },
        secondary: {
            light: baseColors.orange.light,
            base: baseColors.orange.medium
        }
    }
});
export var colors = _objectSpreadProps(_objectSpread({}, baseColors), {
    transparent: baseColors.transparent,
    bg: {
        default: colorVariable("--colors-bg-default"),
        offdefault: colorVariable("--colors-bg-offdefault"),
        inverted: colorVariable("--colors-bg-inverted")
    },
    fg: {
        default: colorVariable("--colors-fg-default"),
        inbetween: colorVariable("--colors-fg-inbetween"),
        inverted: colorVariable("--colors-fg-inverted"),
        error: colorVariable("--colors-fg-error")
    },
    brand: {
        primary: {
            base: colorVariable("--colors-brand-primary-base"),
            light: colorVariable("--colors-brand-primary-light")
        },
        secondary: {
            light: colorVariable("--colors-brand-secondary-light"),
            base: colorVariable("--colors-brand-secondary-base")
        }
    }
});

//# sourceMappingURL=colors.js.map